import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Observable, filter, debounceTime, distinctUntilChanged, map } from 'rxjs';
import { StudentService } from '../../children/service/student.service';
import { MsgModel } from '../msg/model/msg.model';

@Component({
    selector: 'input-ssid',
    templateUrl: './input-ssid.component.html',
    styleUrls: ['./input-ssid.component.scss']
})
export class InputSsidComponent implements OnInit {
    @Input() matLabel: string = 'SSID';
    @Input() placeholder: string = 'SSID';
    @Input() form!: UntypedFormGroup;
    @Input() controlName!: string;
    @Input() studentId!: number;

    isLoading: boolean = false;
    msg!: MsgModel;

    myControl: any;
    filteredOptions!: Observable<any>;

    minCharacters: number = 3;

    constructor(private studentService: StudentService) {}

    ngOnInit(): void {
        this.myControl = <UntypedFormControl>this.form.get(this.controlName);

        this.filteredOptions = this.myControl.valueChanges.pipe(
            // only search if search string is >= 3 characters
            filter((text: string) => text !== null && text.length >= this.minCharacters && this.validateSsid(text, this.myControl)),
            debounceTime(1000),
            distinctUntilChanged(),
            map((value) => this.checkSsid(value))
        );
    }

    checkSsid(ssid: any) {
        this.isLoading = true;
        this.studentService
            .checkExistingStudentSSID(this.studentId, ssid)
            .pipe()
            .subscribe((res) => {
                if (res) {
                    if (res.msg ? res.msg.SUCCESS : false) {
                        this.isLoading = false;
                        this.msg = res.msg;

                        this.myControl.setErrors(this.msg.SUCCESS ? null : { ssid: true });
                    } else {
                        this.myControl.setErrors({ ssid: true });
                        this.msg = res.msg;
                        this.isLoading = false;
                    }
                } else {
                    this.myControl.setErrors({ ssid: true });
                    this.msg = { MSG: 'There was an error checking this SSID.', SUCCESS: false };
                    this.isLoading = false;
                }
            });
    }

    validateSsid(ssid: string, form: UntypedFormControl) {
        const regularExpression = /^[1-9]{1}\d{9}$/;
        const validSSID = regularExpression.test(String(ssid).toLowerCase());

        this.myControl.setErrors(validSSID ? null : { ssid: true });

        return validSSID;
    }
}
